export default [
    {
        name: "supplierId",
        label: "Supplier",
        type: "relation",
        collection: "suppliers",
        entityName: "supplier",
        fields: ["name"],
    },
    {
        name: "contracted",
        label: "Contracted",
        type: "String",
    },
    {
        name: "operationModule",
        label: "Operation Module",
        type: "string",
    },
    {
        name: "signDate",
        label: "Sign Date",
        type: "date",
    },
    {
        name: "endDate",
        label: "End Date",
        type: "date",
    },
    {
        name: "createdAt",
        label: "Creation Date",
        type: "date",
    },
];
